

















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { getCurrentTimezoneOffsetMs } from '@/utils/tool';

/**
 * 时长输入组件
 *
 * @author liyuyao
 * @date 04/08/2020
 */
const baseTime = getCurrentTimezoneOffsetMs();

/** 23:59:00 的毫秒数。 */
const MS_23HH59MM = 86340000;

@Component({ name: 'oncall-time-slot' })
export default class DayTimeSlot extends Vue {
    @Prop({ default: () => [[0, MS_23HH59MM, null, null]] })
    timeSlots: Array<[number, number, number | null, number | null]>;

    @Prop({ default: false })
    disabled: boolean;

    /**
     * 形如 `[开始时间, 结束时间, 关联 groupId]` 的数组.
     *
     * @example
     *
     * ```ts
     * [[10800000, 82740000, null, null]]
     *
     * 10800000：开始时间，相当于 3:00 AM（10800000 毫秒 = 3 小时）
     * 82740000：结束时间，相当于 11:59 PM（82740000 毫秒 ≈ 23 小时）
     * null：关联的值班组 ID
     * null：未使用的字段
     * ```
     */
    timeSlotsValue: Array<[Date | null, Date | null, number | null, number | null]> = [[null, null, null, null]];

    @Prop({ required: true, default: [] })
    wholeGroupList: Array<CommonTypes.OnCallGroupRecord>;

    // 初始化设置 timeSlots
    @Watch('timeSlots', { immediate: true })
    setupTimeSlots(timeSlots) {
        if (timeSlots.length) {
            this.timeSlotsValue = timeSlots.map(slot => {
                // NOTE: baseTime 这个是8小时的时差？？？
                return slot
                    .slice(0, 2)
                    .map(item => new Date(item - baseTime))
                    .concat(slot[2], slot[3] || null);
            });
        }
    }

    getMillisecond(date) {
        if (date) {
            const hour = date.getHours();
            const min = date.getMinutes();
            return (hour * 3600 + min * 60) * 1000;
        } else {
            return 0;
        }
    }

    emitTimeChange() {
        this.$emit('change', this.formatEmitValue);
    }

    deleteTimeSlot(index) {
        this.timeSlotsValue.splice(index, 1);
        this.$emit('change', this.formatEmitValue);
    }

    AddTimeSlot() {
        const previous = this.timeSlotsValue[this.timeSlotsValue.length - 1];
        const previoursEndAt = (previous && previous[1]) || null;
        this.timeSlotsValue.push([previoursEndAt, new Date(MS_23HH59MM - baseTime), null, null]);
    }
    get formatEmitValue() {
        return this.timeSlotsValue.map(slot => {
            return slot
                .slice(0, 2)
                .map(item => this.getMillisecond(item))
                .concat(slot[2], slot[3]);
        });
    }
    computeErrorTip(timeSlot) {
        if (this.disabled) {
            return '';
        }
        if (!timeSlot || timeSlot.length < 2 || !timeSlot[0] || !timeSlot[1]) {
            return '请选择时间段';
        } else if (timeSlot[0] > timeSlot[1]) {
            return '开始时间需要早于结束时间';
        } else if (timeSlot[2] == null) {
            return '请选择绑定的值班组';
        }
        return '';
    }
}
